module.exports = __webpack_public_path__ + "img/cashpo_precheck.91718d98.png";